export const isAdapterConfigUsingCustomCaching = adapter => {
  return 'clearCacheAll' in adapter;
};